import Component from './applicant_grid_item.vue'
export default Component
